module.exports = __webpack_public_path__ + "static/fonts/iconfont.84b3ae6.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/font/iconfont.woff?t=1780902215335
// module id = WDcP
// module chunks = 143